import { Optional } from '../../../../Common/interfaces';
import { Textarea } from '../../../../components';
import { Modal } from '../../../../views';
import {
    LabelBody,
    LabelDisplay2,
    SecondaryButton,
    Spacer,
} from '../../components';
import { useSyncedState } from '../../useSyncedState';

export const data = {
    ['Følelser']: {
        Title: 'Forsøg at indkredse dine følelser i situationen',
        Description:
            'Tanker og følelser kan være svære at skille ad. Men forsøg at finde din følelsesmæssig reaktion på en tanke. Fx kan tanken være, at jeg ikke passer ind, og følelsen er måske usikkerhed.',
        Subtitle: 'Dine følelser',
    },
    ['Tanker']: {
        Title: 'Hvad tænkte du i situationen?',
        Description:
            'Forsøg at indkredse dine tanker i situationen. Tanker kan f.eks. være om dig selv og din indsats, eller sammenligninger med andre.',
        Subtitle: 'Dine tanker',
    },
    ['Krop']: {
        Title: 'Hvordan reagerer din krop i den pressede situation?',
        Description:
            'For mange er maven et kropsligt centrum for en psykisk reaktion. Mærker du mon noget der eller et andet sted i kroppen?',
        Subtitle: 'Din krop',
    },
    ['Adfærd']: {
        Title: 'Hvad gjorde du i situationen? ',
        Description: 'Skriv din adfærd ned.',
        Subtitle: 'Din adfærd',
    },
};

type Props = {
    type: 'Tanker' | 'Følelser' | 'Krop' | 'Adfærd';
    text: string;
    onClose: (text: Optional<string>) => void;
};
export function Module2Exercise1Popup({ type, text: _text, onClose }: Props) {
    const [text, setText] = useSyncedState(_text);
    return (
        <Modal
            title=""
            onClose={() => onClose(null)}
            fullscreen
            className="h-full p-20"
        >
            <LabelDisplay2>{data[type].Title}</LabelDisplay2>
            <LabelBody class="mb-30 mt-10">{data[type].Description}</LabelBody>
            <LabelBody className="mb-5">{data[type].Subtitle}</LabelBody>
            <Textarea
                placeholder="Skriv her..."
                value={text}
                onChangeValue={setText}
            />
            <Spacer />
            <SecondaryButton class="mt-30" onClick={() => onClose(text)}>
                Gem
            </SecondaryButton>
        </Modal>
    );
}
